// @ts-nocheck
/* eslint-disable */
import Address from "~/content/address";
import Admission from "~/content/admission";
import AtAddress from "~/content/ataddress";
import BestImage from "~/content/bestimage";
import Comments from "~/content/comments";
import Contact from "~/content/contact";
import Description from "~/content/description";
import EstateLink from "~/content/estatelink";
import EXIF, { DATE_TAGS } from "~/content/exif";
import Feedback from "~/content/feedback";
import Fuel from "~/content/fuel";
import Groomer from "~/content/groomer";
import HotelClass from "~/content/hotelclass";
import HotelDesc from "~/content/hoteldesc";
import HotelGallery from "~/content/hotelgallery";
import HotelCheck from "~/content/hotelcheck";
import Inaccurate from "~/content/inaccurate";
import InfoLinks from "~/content/infolinks";
import KeyValueTags from "~/content/keyvaluetags";
import KeyValue from "~/content/keyvalue";
import KeyVal from "~/content/keyval";
import Leaflets from "~/content/leaflets";
import Lifetime from "~/content/lifetime";
import Link from "~/content/link";
import SmallMap from "~/content/smallmap";
import Media from "~/content/media";
import MymapsPlace from "~/content/mymapsplace";
import ManageMyCompany from "~/content/managemycompany";
import Offers from "~/content/offers";
import Services from "~/content/services";
import Opening from "~/content/opening";
import Parking from "~/content/parking";
import Partner from "~/content/partner";
import Photo from "~/content/photo";
import PhotoAuthor from "~/content/photoauthor";
import Place from "~/content/place";
import PlaceholderImage from "~/content/placeholderimage";
import POILink from "~/content/poilink";
import Poster from "~/content/poster";
import Price from "~/content/price";
import Review from "~/content/review";
import Signs from "~/content/signs";
import Snow from "~/content/snow";
import SubTitle from "~/content/subtitle";
import TableReservation from "~/content/tablereservation";
import TakeDate from "~/content/takedate";
import Title from "~/content/title";
import TransportLines from "~/content/transportlines";
import TypeName from "~/content/typename";
import Video from "~/content/video";
import WeatherContent from "~/content/weather";
import WebCam from "~/content/webcam";
import WindyWebCam from "~/content/windy-webcam";
import News from "~/content/news";
import Report, { reportPoiType, NON_REPORTED_POITYPES } from "~/content/report";
import DetailPoisContent from "~/content/detailpois";
import DiInfo from "~/content/diinfo";
import ReportLocalChanges from "~/content/reportlocalchanges";
import BookingLink from "~/content/booking-link";
import Form from "~/search/form";
import { logSuggestSearchSelection } from "~/search/analytics";
import { getDetailSize } from "~/util/cdn";
import { icon, node } from "~/util/dom";
import createHeaderButton from "~/ui/headerbutton";
import { CHEVRON_LEFT_16, CLOSE_16 } from "@sznds/icons";
import { addListener, removeListener, makeEvent } from "~/lib/signals";
import { CONFIG } from "~/config";
import IconAction from "~/ui/icon-action";
import ContentOverlay from "~/content.overlay";
import ContentFull from "~/content.full";
import { showMarkerLabel } from "~/util/markerTitle";
import { isFirmFromPoi, firmStats, getFirmLayout, getReviewConf, reviewHasGreenBadge, reviewHasColoredBadge } from "~/util/review";
import { getTitle, isDetailActive, parseGallery, postProcessPOI, isPhotoDetail } from "~/util/detail";
import GPSSwitch from "~/es6/gpsswitch";
import { _ } from "~/i18n";
import MyMapsShare from "~/es6/mymaps.share";
import SceneConst from "~/scene/common/const";
import Scene from "~/scene";
import { loadDetail, setDetail, unsetDetail } from "~/state/detail/state";
import { store } from "~/state/store";
import { Unsubscribe } from "redux";
import { watch, watchDetail, watchMapset, watchCoordinates, watchAnimation, watchMapZoom } from "~/state/util";
import { IPoi } from "~/interfaces";
import Canonical from "~/canonical";
import { getMapsetBySEO, isM3dAvailable } from "~/util/mapset";
import { ROUTE_CONST } from "~/route/const";
import { IMapState } from "~/state/map/interfaces";
import { setCoordinates } from "~/state/map/state";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";
import { getIcon } from "./util/providers/poiagg";
import ControlPointer from "~/ui/controls/pointer";
import mapControls from "~/scene/control/mapcontrols";
import { getPointerDistance, getPointerCenterPx } from "./util/pointer";
import { getPanoAtCoords } from "./util/providers/pano";
import { Utils as PanoUtils } from "@mapy/panorama/dist/panorama-private";
import { DEFAULT_DETAIL_STATE } from "~/state/detail/constants";
import { getCreateLikeData, isPoiSaved, mapyboxAnalyticsSave } from "./util/mapybox";
import MyMapsMapyBoxItem from "./ui/dialogs/mymaps-mapybox-item";
import { getFolderData } from "./util/providers/mapybox";
import { getRibbon } from "./ribbon/handler";
import Inactive from "./content/inactive";
import { deferPromise } from "~/util/general";
import { getBookingLink } from "~/util/providers/booking-link";
import { createCommercialCollaboration } from "~/ui/commercialCollaboration";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import { MYMAPS_SHARE, SIGNPOST, TRIPS_AROUND } from "~/ui/sds-compatible-icons";
import * as Sentry from "@sentry/browser";
import IconActionDropdown from "~/ui/icon-action-dropdown";
import { HIKE_MAP_24 } from "~/util/sds-compatible-icons";
import ContextMenuItem from "~/ui/contextmenuitem";
import createSDSIcon from "~/ui/icon";
import { ACTIVITY_ALPINIST } from "~/activities/sds-icons";
import { confirm } from "~/ui/dialogs/confirm";
import WasmStoreMarker from "./wasm/store/wasm-store-marker";
import WasmStoreGeometry from "./wasm/store/wasm-store-geometry";
import { IWasmStoreGeometry } from "./wasm/store/interfaces";
import { getMarkerImgFrompoi, sceneCoordsToPoints } from "./util/wasm";
import { WASM_ZINDEX } from "./wasm/const";
import WasmHiddenPois from "./wasm/hidden-pois";

function isOwner(data) {
	return data?.admin_urls?.edit;
}

/**
 * @class Zobrazovac detailu.
 * @signal detail-activated Signalizuje definitivni nacteni a otevreni detailu
 * @signal detail-deactivated Deaktivace detailu
 * @signal detail-error Chyba pri nacteni detailu, {Number} status requestu
 */
export default class Detail extends ContentOverlay {
	_storeDetailUnsubscribe: Unsubscribe;

	_storeMapUnsubscribe: Unsubscribe;

	_storeCoordinatesUnsubscribe: Unsubscribe;

	_storeAnimationUnsubscribe: Unsubscribe;

	_storeZoomUnsubscribe: Unsubscribe;

	_drop: ControlPointer;

	_broadCast: BroadcastChannel;

	_wasmMarker: WasmStoreMarker;

	_wasmGeometry: WasmStoreGeometry;

	_data: IPoi;

	_wasmHiddenPois: WasmHiddenPois;

	constructor() {
		super();

		this._contentName = "detail";
		this._dom = {
			container: node("div", { id: "detail", className: "detail2" }),
			// visualisace dat
			topImage: node("div", { className: "top-image" }),
			modules: node("div", { className: "modules" }),
			modulesInner: node("div", { className: "inner clr" }),
			pano: node("button", { innerHTML: _("detail.view.pano"), className: "icon panorama" }),
			m3d: node("button", { innerHTML: _("detail.view.3D"), className: "icon m3d" }),
			webcam: node("button", { innerHTML: _("detail.view.webcamlive"), className: "icon webcam" }),
			btnContainer: node("div", { className: "button-top" }),
			relatedFirm: node("div", { className: "related-firm" }),
			btnContainerBack: node("div", { className: "button-back" }),
			backBtn: createHeaderButton({
				icon: CLOSE_16,
				innerHTML: _("close"),
			}),
			panoHref: null,
			galleryPlaceholder: node("span", { className: "gallery-placeholder" }),
			header: node("div", { className: "header" }),
		};

		this._dom.container.classList.add("detail-suggest");

		this._dom.backBtn.setAttribute("type", "button");
		this._drop = null;

		/* DOM pro sepecificke casti visualizace dat */
		this._dom.pano.addEventListener("click", this, false);
		this._dom.m3d.addEventListener("click", this, false);
		this._dom.webcam.addEventListener("click", this, false);
		this._dom.backBtn.addEventListener("click", this, false);

		JAK.DOM.append([this._dom.btnContainer, this._dom.pano, this._dom.galleryPlaceholder, this._dom.webcam, this._dom.m3d]);
		JAK.DOM.append([this._dom.btnContainerBack, this._dom.backBtn]);

		this._searchForm = this._getSearchForm();

		this._buildCloseButton();
		this._dom.closeButton.classList.add("detail");

		/* promene pro visualizaci dat */
		this._data = null;
		this._geometry = null;
		this._geometryLayer = null;
		this._contents = [];
		this._poster = null;
		this._posterContents = {};
		this._panoPromise = null;
		this._dataPromise = null;
		this._marker = null;
		this._reported = [];
		this._detailFrpc = null;
		this._likeData = null;
		this._likeOpen = false;
		this._dimListener = null;
		this._gps = null;
		this._showLabel = 0;
		this._broadCast = null;
		this._stateSearch = null;
		this._reviewMode = "";
		this._drrid = 0;
		this._immediatelyOpenReview = false;
		this._openReviewData = null;
		this._detailLoadWatcher = null;
		this._bookingLinkProm = null;
		this._wasmMarker = null;
		this._wasmGeometry = null;
		this._wasmHiddenPois = null;

		this._actions = {
			route: new IconAction({
				href: "?planovani-trasy",
				icon: "navigate",
				title: _("action.route.title"),
				callback: async () => {
					const routeState = Mapy.CML.state.route;
					const route = Mapy.getComponent("route");
					const { data, mark } = store.getState().detail;

					if (route.isActive()) {
						route.deactivate();
					}

					this.sendFirmStats("route", data, { placeId: 1, typeId: 3 });

					if (routeState.readOnly) {
						await route.activate();
						route.readOnlyError();
						Mapy.getComponent("history").save();

						return;
					}

					if (!routeState?.items?.length) {
						Mapy.CML.state = {
							route: {
								params: {
									criterion: data.source === "pubt" ? 200 : Mapy.CML?.state.route?.params?.criterion || 111,
									type: data.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
								},
							},
						};
					}

					const addAkaCoords = ["foto", "ffoto", "wcam"].indexOf(data.source) > -1;
					const coords = Scene.coordsFromWGS84(mark.lon, mark.lat);

					await route.addItem({
						coords,
						position: ROUTE_CONST.position.end,
						name: data.title,
						...this._likeData && (this._likeData.usertitle || this._likeData.title) ? { usertitle: this._likeData.usertitle || this._likeData.title } : {},
						source: addAkaCoords ? "coor" : data.source,
						id: ["coor", "closure"].indexOf(data.source) === -1
							? addAkaCoords ? `${mark.lon},${mark.lat}` : parseFloat(data.id)
							: data.id,
						desc: data.title,
						..."typeId" in data ? { typeId: data.typeId } : {},
						...this._likeData ? { favoriteId: this._likeData.id } : {},
					});

					await route.activate();

					Mapy.getComponent("history").save();
				},
			}),
			save: new IconAction({
				icon: "star-line",
				title: _("action.save.title"),
				log: false,
				callback: () => {
					const data = this._buildActionData();
					const { source, id } = this._data;
					const type = data.source === "coor" ? "point" : "entity";
					const isSaveAsNew = this._likeData && "parent_name" in this._likeData;
					const folderData = getFolderData();

					Mapy.getComponent("logger").log("click", {
						text: "uložit_hvězda",
						type: type,
					});

					new MyMapsMapyBoxItem({
						isPremiumUser: isPremiumNoteUser(),
						noteVersion: getNoteVersion(),
						createData: getCreateLikeData({
							...data,
						}, data.source === "coor" ? "point" : "entity"),
						...folderData
							? {
								folder: folderData,
							}
							: {},
						...isSaveAsNew
							? {
								// nejde nahradit
								mode: "save-as-new",
								likeData: this._likeData,
								folder: {
									id: this._likeData.parent_id,
									title: this._likeData.parent_name,
								},
							}
							: {
								mode: "create",
							},
						onSave: ({ likeData: newLikeData }) => {
							if (this._likeData) {
								Object.assign(this._likeData, newLikeData);
							}

							mapyboxAnalyticsSave({
								type: "poi",
								note: !!newLikeData.description,
							});
							Mapy.getComponent("logger").log("click", {
								source,
								id,
								type,
								origin: "web",
							});

							if (source === this._data.source && id === this._data.id) {
								Mapy.getComponent("dimcurator").setState({ dim: newLikeData.id }).loadData().then(() => {
									Mapy.getComponent("history").save();
								}, () => {});
							}
						},
					}).open();
				},
			}),
			share: new IconAction({
				icon: "",
				sdsIcon: MYMAPS_SHARE,
				title: _("action.share.title"),
				callback: () => {
					const data = this._likeData
						? {
							...this._likeData,
							like: !("owner_name" in this._likeData),
							showLabel: !!this._likeData,
						}
						: {
							title: this._data.title,
							type: this._data.source === "coor" ? "point" : "entity",
						};
					let sharePopup = new MyMapsShare(data, cbData => {
						if (cbData.name === "popup-close") {
							if (this._likeData && this._likeData.public !== cbData.public) {
								this._likeData.public = cbData.public;
								Mapy.getComponent("places").listRefreshData();
							}
						}
						sharePopup.destroy();
						sharePopup = null;
					});

					sharePopup.open();
				},
			}),
			triptips: (() => {
				const menu = new IconActionDropdown({
					icon: SIGNPOST,
					title: _("action.triptips.title2"),
					items: [
						{
							icon: createSDSIcon({
								symbol: ACTIVITY_ALPINIST,
							}),
							text: _("action.circuitroute.title"),
							onClick: async event => {
								event.stopPropagation();
								if (!Mapy.CML.state.route.items?.length || await confirm(_("alwaysOnMap.route.promptRewrite.cancel"), _("alwaysOnMap.route.promptRewrite.confirm"), _("alwaysOnMap.route.promptRewrite.body"))) {
									const newRouteState = {
										route: {
											zoom: true,
											items: [{
												id: this._data.id,
												images: null,
												source: this._data.source,
												geometry: Scene.coordsToString([this._data.coords]),
												title: this._data.title,
												desc: this._data.locationMain || this._data.titleVars?.locationMain1 || "",
												planTrip: true,
												position: ROUTE_CONST.position.start,
												favoriteId: "",
												usertitle: "",
												noGEOPosition: true,
											}],
											params: {
												tripCriterion: ROUTE_CONST.circuitTypes.trial.criterion[0],
												type: ROUTE_CONST.TYPE_WALK,
											},
										}
									};

									store.dispatch(unsetDetail());
									await Mapy.getComponent("route").activate();
									Mapy.CML.state = newRouteState;
									Mapy.getComponent("history").save();
								}

								Mapy.getComponent("logger").log("click", {
									text: "Výlet po okolí",
									origin: "poi_detail",
								});
							},
						},
						{
							icon: createSDSIcon({
								symbol: TRIPS_AROUND,
							}),
							text: _("action.triptips.title"),
							onClick: event => {
								event.stopPropagation();
								Mapy.getComponent("search").activate();
								Mapy.getComponent("search").setState({
									q: _("action.triptips.search"),
									searchOrigin: "detail_trips",
								});
								store.dispatch(unsetDetail());
								Mapy.getComponent("history").save();
								Mapy.getComponent("logger").log("click", {
									text: "Tipy na výlet",
									origin: "poi_detail",
								});
							},
						},
					],
					itemFactory: (item, menu) => {
						const menuItem = new ContextMenuItem({
							...item,
							onClick: event => {
								menu.open(false, event);
								item.onClick(event);
							},
						});

						menuItem.container.setAttribute("data-log-ignore", "1");

						return menuItem.container;
					},
				});

				menu.container.setAttribute("data-log-ignore", "1");
				menu.container.addEventListener("click", () => {
					Mapy.getComponent("logger").log("click", {
						text: "Výlet",
						origin: "poi_detail",
					});
				}, false);

				return menu;
			})(),
			report: new IconAction({
				icon: "rename",
				log: false,
				ownLog: () => {
					Mapy.getComponent("logger").log("click", {
						text: "Nahlasit problem",
						source: "fotky",
					});
				},
				title: _("photoContextMenu.reportBad"),
				callback: () => {
					if ((this._data.source === "foto" || this._data.source === "ffoto") && "extend" in this._data && "photo" in this._data.extend && "src" in this._data.extend.photo) {
						Mapy.BadPhoto.data = {
							id: this._data.id,
							url: this._data.extend.photo.src,
							coords: this._data.mark,
						};
						Mapy.BadPhoto.open();
					} else {
						Mapy.getComponent("reportDefect").activate();
						Mapy.getComponent("history").save(true);
					}
				},
			}),
		};

		// scene signals
		this._ss = [];
		this._storeAnimationUnsubscribe = null;
		this._storeZoomUnsubscribe = null;
		this._place = null; /* predem nachystane misto; instance PanoPlace (pro prechod do detailu panoramatu) */

		addListener(this, "print-page", "_printPage");
		addListener(this, "print-done", "_printDone");
		this._printPromise = null;
		this._bigImage = null;

		const wt = watch(store.getState, "detail", watchDetail);

		this._storeDetailUnsubscribe = store.subscribe(wt((newDetail, oldDetail) => {
			const { data, status, loading } = newDetail;

			// mame data, vykreslime detail
			if (data) {
				if (this._data) {
					const change = this._data.source !== data.source || this._data.id !== data.id;

					this._data.source = data.source;
					this._data.id = data.id;

					change && Mapy.getComponent("history").save(true);
				}

				this.activate();
				this._response({
					poi: window.structuredClone(data),
					status,
				});
			// nejsou data a uz se nenacita, takze bud chyba nebo nekdo zavrel detail - v obou pripadech se deaktivujeme
			} else if (!loading) {
				this.deactivate();
			}

			if (newDetail.loading !== oldDetail.loading) {
				const loaderComp = Mapy.getComponent("loader");
				const ribbon = getRibbon();

				if (ribbon && data) {
					// nacteme pres ribbon
					const state = ribbon.setPhantomLoad();

					// nechceme resit nacteni detailu pres loader
					if (loaderComp.getFirstLoad() && state) {
						loaderComp.skipFirstLoad();
					}
				}

				if (newDetail.loading) {
					loaderComp.start(true);
				} else {
					loaderComp.end(true);
				}
			}

			if (!loading) {
				if (status === 200) {
					this._dataPromise?.fulfill();
				} else {
					this._dataPromise?.reject();
				}
			}
		}));
	}

	destroy(): void {
		this._storeDetailUnsubscribe();
		super.destroy();
	}

	activate() {
		// FIXME: this.isActive ponechano schvalne, casem nebude potreba, ale ted to bez nej nefunguje
		if (this.isActive()) {
			const reviewsListComp = Mapy.getComponent("reviewslist");

			if (reviewsListComp.isActive()) {
				reviewsListComp.deactivate();
			}

			return this;
		}

		this._drop = new ControlPointer({
			type: "red",
			snapHUDtoScreen: 25,
			showCaption: true,
			onClick: () => {
				const [longitude, latitude] = this._data.coords.toWGS84();

				store.dispatch(setCoordinates({
					longitude,
					latitude,
					animate: true,
				}));
				Mapy.getComponent("history").save();
			},
		});

		if (!this._wasmHiddenPois) {
			this._wasmHiddenPois = Mapy.getComponent("wasm").createHiddenPoiList("detailPois");
		}

		this._ss.push(Scene.addListener("marker-click", "_markerClick", this));
		this._bigImage = null;
		this._dimListener = addListener(this, "dim-is-not-share", data => {
			if (this._likeData && data.data.dim === this._likeData.id) {
				this._likeData = null;
				this._rebuildDetail();
				Mapy.getComponent("dimcurator").setState();
				Mapy.getComponent("history").save();
			}
		}, Mapy.getComponent("dimcurator"));

		// pri zmene mapsetu poladime zobrazeni/schovani tlacitka pro zapnuti 3D
		const wtMapset = watch(store.getState, "map", watchMapset);
		const wtCoordinates = watch(store.getState, "map", watchCoordinates);

		this._storeMapUnsubscribe = store.subscribe(wtMapset((newMap, oldMap) => {
			if (newMap.mapset !== oldMap.mapset) {
				this._setM3dAvail(newMap);
			}
		}));
		this._storeCoordinatesUnsubscribe = store.subscribe(wtCoordinates((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this._mapRedraw();
			}
		}));

		mapControls.addControlPointer(this._drop);

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		if (window.BroadcastChannel) {
			this._broadCast = new BroadcastChannel("detail_broadcast");

			this._broadCast.onmessage = e => {
				const msg = JSON.parse(e.data);

				switch (msg.type) {
					case "firm-review":
						// spravny detail, posleme si data
						if (this._data.source === msg.data.source && this._data.id === msg.data.id) {
							const detail = {
								rusAdmin: msg.data.rusAdmin,
								review: msg.data.review,
								myReview: msg.data.myReview,
							};

							window.dispatchEvent(new CustomEvent("firmreview-review-myreview", {
								detail,
							}));
							window.dispatchEvent(new CustomEvent("firmreview-comments-myreview", {
								detail,
							}));
						}
						break;

					default:
						//
				}
			};
		}

		const detailWatcher = watch(store.getState, "detail", watchDetail);

		this._detailLoadWatcher = store.subscribe(detailWatcher((newDetail, oldDetail) => {
			if (!newDetail.loading && oldDetail.loading) {
				const loadError = newDetail.data === null && newDetail.source !== DEFAULT_DETAIL_STATE.source && newDetail.id !== DEFAULT_DETAIL_STATE.id;

				if (loadError) {
					Notifications.notify({
						content: _("detail.loadError"),
						type: NOTIFICATIONS_TYPE.ERROR,
						autohide: true,
					});
				}
			}
		}));

		return super.activate();
	}

	deactivate() {
		// FIXME: this.isActive ponechano schvalne, casem nebude potreba, ale ted to bez nej nefunguje
		if (!this.isActive()) {
			return this;
		}

		this._onCloseAction && this._onCloseAction();

		if (this._data) {
			this._clearDOM();
			this._clear();

			if (this._likeData) {
				this._likeData = null;
				Mapy.getComponent("dimcurator").setState();
			}
		}

		this._stateSearch = null;
		this._bookingLinkProm = null;

		Mapy.Util.clear(this._dom.container);
		Mapy.Util.clear(this._dom.header);

		[this._dom.pano, this._dom.webcam, this._dom.m3d].forEach(element => {
			element.style.display = "";
		});

		mapControls.removeControlPointer(this._drop);
		Scene.removeListeners(this._ss);

		removeListener(this._dimListener);
		this._storeMapUnsubscribe?.();
		this._storeCoordinatesUnsubscribe?.();

		if (this._dom.container.offsetHeight) {
			// pokud nema vysku, znamena to ze je schovany a deaktivujeme ho na pozadi
			const layout = Mapy.getComponent("layout");

			if (layout.getWidth() > 1) {
				layout.setWidth(1);
			}
		}

		this._removeCloseButton();

		this._printPromise = null;
		this._bigImage = null;

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);
		this._broadCast?.close();
		this._broadCast = null;
		this._detailLoadWatcher && this._detailLoadWatcher();
		this._detailLoadWatcher = null;

		if (this._searchForm) {
			this._searchForm.closeSuggest();
			this._searchForm.clearSuggestItems();
		}

		if (this._wasmHiddenPois) {
			this._wasmHiddenPois.clear();
			this._wasmHiddenPois.updateWasm();
		}

		super.deactivate();
		makeEvent("detail-deactivated", this);
		this._openReviewData = null;

		store.dispatch(unsetDetail());

		return this;
	}

	getBroadCast() {
		return this._broadCast;
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);
		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState({ dim: this._likeData.id });
		}

		return super.show();
	}

	hide() {
		if (this._likeData) {
			Mapy.getComponent("dimcurator").setState();
		}

		return super.hide();
	}

	/**
	 * Pokud je aktivovany detail a pravy panel je skryty, pri kliku na POI detailu jej zobrazime.
	 */
	refreshPanel() {
		const state = store.getState();

		if (isDetailActive(state)) {
			Mapy.getComponent("layout").setWidth(1);
		}
	}

	clearSearch() {
		this._stateSearch = null;
	}

	getData() {
		return this._data;
	}

	getMarker() {
		return this._marker;
	}

	getFromMarker() {
		return this._data.fromMarker;
	}

	getGalleryData() {
		return this._galleryData;
	}

	setMarkerVisibility(visible) {
		if (!this._marker) { return; }
		if (this._marker.appended) {
			Mapy.getComponent("masakovac").removeMarker(this._marker);
		}

		if (visible && this._data && this._data.source !== "wcam") {
			this._wasmMarker.update({
				visible: !this._data?.extend?.signs,
			});
			if (!this._marker.appended && this._marker.getCoords()) {
				Mapy.getComponent("masakovac").addMarker("detail", this._marker, this._data.source, this._data.id);
			}
		}
	}

	reload() {
		const state = store.getState();

		if (isDetailActive(state)) {
			const { data } = state.detail;

			this._clearDOM();
			this._clear();
			this._data = {
				source: data.source,
				id: data.id,
				show: !Mapy.getComponent("gallery").isActive(), // chceme znovu zazoomovat, jen pokud neni aktivni galerie
			};
			store.dispatch(loadDetail({
				source: data.source,
				id: data.id,
				showZ: this._data.show?.z || "",
			}));
		}
	}

	getState() {
		if (!this._data || this._likeData) {
			return {};
		}

		if (this._data.source === "closure") {
			return Mapy.getComponent("route").getState();
		}

		const state = Object.assign(Mapy.getComponent("search").getState(), {
			source: this._data.source,
			id: this._data.id,
		});

		this._contents.forEach(function(c) {
			var cState = c.getState();
			var keys = Object.keys(cState);

			keys.forEach(function(k) {
				state[k] = cState[k];
			});
		});

		// komponenty spojene s detailem - kvuli uprave history.js se musi explicitne pridavat pres detail state
		["pano", "webcam", "timeboard"].forEach(function(compName) {
			var comp = Mapy.getComponent(compName);

			if (comp.isActive()) {
				Object.assign(state, comp.getState());
			}
		});

		if (Mapy.getComponent("reviewslist").isActive()) {
			state.recenze = 1;
		}

		// ds - detail suggest
		if (this._stateSearch && (!Mapy.getComponent("gallery").isActive() || Mapy.getComponent("gallery").getData().source !== "author")) {
			// 0 vypnuto, 1 mame suggest, 2 mame suggest a vysledky
			state.ds = this._stateSearch.hasResults ? 2 : 1;
		}

		return state;
	}

	setState(state) {
		this._dom.backBtn.removeEventListener("click", this, false);

		const backBtn = createHeaderButton({
			icon: state.backTitle ? CHEVRON_LEFT_16 : CLOSE_16,
			innerHTML: state.backTitle || _("close"),
		});

		this._dom.backBtn.replaceWith(backBtn);
		this._dom.backBtn = backBtn;
		this._dom.backBtn.addEventListener("click", this, false);
		this._backAction = state.backAction || null;
		this._onCloseAction = state.onClose || null;

		this._actions.save.updateProps = {
			change: false,
			title: _("action.save.title"),
		};

		if ("likeData" in state) {
			this._showLabel = showMarkerLabel(state.showLabel, state.likeData.usertitle, this._data?.title);

			if ((this._likeData && this._likeData.id === state.likeData.id) || (!this._likeData && this._data && state.likeData.source === this._data.source && state.likeData.source_id === this._data.id)) {
				this._likeData = state.likeData;

				this._rebuildDetail();

				return Promise.resolve();
			}

			if (state.source !== "coor") {
				state.id = state.likeData.source_id;
				state.source = state.likeData.source;
			}
		} else if (this._likeData) {
			this._likeData = null;
			Mapy.getComponent("dimcurator").setState();
		// FIXME: this.isActive ponechano schvalne, casem nebude potreba
		}

		this._stateSearch = state.search;

		if (state.ds) {
			const dsValue = parseFloat(state.ds) || 0;

			if (dsValue === 1 || (dsValue === 2 && state.q)) {
				this._stateSearch = {
					query: state.q || "",
					hasResults: dsValue,
				};
			}
		}

		if ("dra" in state) {
			switch (state.dra) {
				case "update":
					this._reviewMode = "update";
					break;

				default:
					//
			}
		} else {
			this._reviewMode = "";
		}
		this._drrid = state.drrid || 0;

		this._immediatelyOpenReview = state.startreview === "1";
		this._openReviewData = "service" in state
			? {
				service: state.service,
			}
			: null;

		const source = state.source;

		if (!source || source === "author") {
			store.dispatch(unsetDetail());

			return Promise.reject();
		}

		this._dataPromise = new JAK.Promise();

		const layout = Mapy.getComponent("layout");

		if (layout.getWidth() === 0 && state.manual) {
			if (Mapy.Util.isSmallResolution()) {
				layout.setWidth(0);
			} else {
				layout.setWidth();
			}
		} /* jen pokud to neni z URL; jinak musime sirku respektovat */
		this.activate(); /* kdyz se v URL objevi nase data, musime se holt sami zaktivovat */

		if (this._data) {
			if (Mapy.getComponent("layout").getWidth() === 2) {
				if (Mapy.Util.isSmallResolution()) {
					layout.setWidth(0);
				} else {
					layout.setWidth();
				}
			}

			this._clear();
		}

		this._setSuggest();

		this._likeData = "likeData" in state ? state.likeData : null;
		this._data = {
			source: state.source,
			id: ["coor", "closure"].indexOf(state.source) > -1 ? state.id : parseInt(state.id),
		};

		let mark = null;

		if ("coords" in state) {
			const [lon, lat] = state.coords.toWGS84();

			mark = { lon, lat };
			this._data.coords = state.coords;
		}
		if ("gpsCoords" in state) {
			const [lon, lat] = state.gpsCoords.toWGS84();

			mark = { lon, lat };
			this._data.coords = state.gpsCoords;
		}

		if (source === "closure") {
			this._data.title = state.title;
			this._data.description = state.description;
		}

		// zoom pro iframe
		if (CONFIG.inFrame) {
			if ("show" in state || !state.z) {
				/* pokud v URL neni zoom, chceme take nazoomovat na detail */
				if (Mapy.getComponent("history").isFromHistory()) { // pro sdileni v iframu predame zoom, kdyby byl potreba
					const { zoom } = store.getState().map;

					this._data.show = { z: zoom };
				} else {
					this._data.show = {};
				}
			} else { // pro sdileni v iframu predame zoom, kdyby byl potreba
				this._data.show = { z: state.z };
			}
		// normal zoom
		} else if ("show" in state) {
			this._data.show = state.show ? {} : null;
			// pokud v URL neni zoom, chceme take nazoomovat na detail
		} else {
			this._data.show = state.z ? null : {};
		}

		if ("weather" in state) {
			this._data.weatherShow = true;
		}

		if ("windy" in state) {
			this._data.weatherWindy = true;
		}

		if ("fromMarker" in state) {
			this._data.fromMarker = state.fromMarker;
		}

		if ("markerIcon" in state) {
			this._data.markerIcon = state.markerIcon;
		}

		if (state.recenze === "1") {
			this._data.recenze = true;
		} else {
			const reviewsListComp = Mapy.getComponent("reviewslist");

			if (reviewsListComp.isActive()) {
				reviewsListComp.deactivate();
			}
		}

		if (state.zoomToReviews) {
			this._data.zoomToReviews = true;
		}

		if (state.openReviewPopup) {
			this._data.openReviewPopup = state.openReviewPopup;
		}

		// otevrit upload
		if (state.upload === "1") {
			this._data.upload = true;
		}

		// vlastni data
		if (state.detailData) {
			const data = {
				...state.detailData.poi,
				extend: {
					...state.detailData.poi.extend ? state.detailData.poi.extend : {},
				},
			};

			postProcessPOI(data);
			store.dispatch(setDetail({
				data,
				...mark ? { mark } : {},
			}));
		} else {
			store.dispatch(loadDetail({
				source: this._data.source,
				id: this._data.id,
				showZ: this._data.show?.z || "",
				...mark ? { mark } : {},
			}));
		}

		return Promise.all([this._dataPromise]);
	}

	// eslint-disable-next-line class-methods-use-this
	historyAfterState(state) {
		if (!("x" in state && "y" in state && "z" in state)) {
			Mapy.getComponent("history").save(true);
		}
	}

	/* metody pro visualisaci dat */
	handleEvent(e) {
		switch (e.currentTarget) {
			case this._dom.pano: /* prepnout na detail panoramatu */
			case this._dom.panoHref:
				e.preventDefault();

				if (isFirmFromPoi(this._data) && e.currentTarget === this._dom.pano) {
					this.sendFirmStats("pano", this._data, { placeId: 1, typeId: 33 });
				}

				this._preActivatePanorama();
				break;

			case this._dom.m3d: /* prepnout na detail 3d map */
				const coords = this.getMarker().getCoords().toWGS84();

				if (Scene.isMapActive() || CONFIG.wasmEnabled) {
					store.dispatch(setCoordinates({
						longitude: coords[0],
						latitude: coords[1],
						zoom: Mapy.Util.computeZoom(this._data),
					}));
					Scene.setActive("m3d").then(() => {
						Mapy.getComponent("history").save();
					}, () => {});
				}
				break;

			case this._dom.webcam:
				this._activateWebcam();
				Mapy.getComponent("history").save();
				break;

			case this._dom.backBtn:
				if (this._backAction) {
					this._backAction(e);
				} else {
					this._clickClose();
				}
				break;

			default:
				//
		}

		if (e.type === "photo-detail-close" || e.type === "photo-gallery-close") {
			// FIXME: tady je evidentne chyba, protoze se melo this.isActive volat a ne jen kontrolovat existence, ktera je samozrejme vzdycky true - opravime ale, az bude mergnuto, aby bylo jasne, ze pripadna zmena chovani neni chyba zavedeni reduxu, ale tohohle
			this.isActive && !Mapy.getComponent("gallery").isActive() && this._data?.extend && this.setSEO();
		}
	}

	openGallery() {
		this._contents.forEach(function(content) {
			if (content instanceof Media) {
				content.openGallery();
			}
		});
	}

	galleryClose() {
		if (this.isActive()) {
			setTimeout(() => {
				mapControls.syncPortPointers();

				for (const content of this._contents) {
					if (content instanceof Comments) {
						content.tryToRunScroll();
						break;
					}
				}
			}, 100);
		}
	}

	openTimeboard() {
		this._contents.forEach(function(content) {
			if (content instanceof TransportLines) { content.openTimeboard(); }
		});
	}

	getPanoPosterData() {
		return this._panoPromise;
	}

	changeTitle(title) {
		this._data.title = title || "";
	}

	getPanoImg() {
		return this._panoImg;
	}

	getSuggestConf() {
		this._stateSearch = {
			...this._stateSearch,
			...Mapy.getComponent("search").hasResults() ? {
				query: Mapy.getComponent("search").getQuery(),
				hasResults: Mapy.getComponent("search").hasResults(),
			} : {},
		};

		return this._searchForm && Object.keys(this._stateSearch).length ? this._stateSearch : null;
	}

	setSEO() {
		if (!this._data) return;

		var title;

		/**
		 * Pro firmy s & v title -> nechceme prevadet na &amp; stejne pro coords ',"
		 */
		if (this._data.source === "coor" || getTitle(this._data, this._likeData).indexOf("&") !== -1) {
			title = Mapy.Util.escapeTags(getTitle(this._data, this._likeData));
		}
		else {
			title = Mapy.Util.decodeEntities(Mapy.Util.escapeHTML(this._data.title));
		}

		var type = this._data.typeName ? " (" + this._data.typeName + ")" : "";

		if (this._data.typeName == _("detail.content.typename")) {
			type = "";
		}

		var description = "";

		if (this._data.description) {
			var MAX_LEN = 150;
			var wholeDescription = this._data.description.replace(/<[^>]*>/g, ""); // remove tags
			var parts = wholeDescription.split(" ");

			parts.every((part, ind) => {
				const ws = ind > 0 ? " " : "";
				const test = part.length + ws.length + description.length <= MAX_LEN;

				if (test) {
					description += ws + part;

					return true;
				}

				description += "...";

				return false;
			});

			if (this._data.extend.poi.booking) {
				description = _("detail.content.booking.description", { city: this._data.locationMain ? this._data.locationMain : "", title: this._data.title }) + " " + description;
			}
		}
		else {
			description = _("detail.seo", {
				title: title,
				type: type,
			});
		}

		Mapy.SEO.set(
			(this._data.weatherShow ? _("weather.title") + " " : "") + "{title}{type}".replace("{title}", title).replace("{type}", type) + (this._data.extend?.poi?.booking ? " " + _("detail.content.booking.reservation").toUpperCase() : ""),
			(this._data.weatherShow ? _("detail.weather.seoDescription", { title: title }) + " " : description)
		);

		const seoObj = {
			source: this._data.source,
			id: this._data.id,
		};

		if (this._data.weatherShow) {
			seoObj[Mapy.Util.removeDiacritic(_("weather.title")).toLowerCase()] = this._data.title.replace(" ", "-");
		}

		Canonical.set("/", seoObj);
	}

	// verejna, aby ji mohly volat contenty
	sendFirmStats(type, data, specParam) {
		if (this._reported.indexOf(type) === -1) {
			firmStats(type === "open" ? "firmy-vizitka-doruceni" : "firmy-vizitka-akce", data, specParam);
			this._reported.push(type);
		}
	}

	clearLikeData() {
		if (this._likeData && this.isActive()) {
			this._likeData = null;
			this._actions.save.updateProps = {
				change: false,
				title: _("action.save.title"),
			};
			this._rebuildDetail();
			Mapy.getComponent("dimcurator").setState();
			Mapy.getComponent("history").save();
		}
	}

	_clear() {
		this._storeAnimationUnsubscribe?.();
		this._storeAnimationUnsubscribe = null;
		this._storeZoomUnsubscribe?.();
		this._storeZoomUnsubscribe = null;
		this._drop.setPosition(null);
		this.setMarkerVisibility(false);
		Canonical.remove();

		this._poster = null;
		this._posterContents = {};
		this._data = null;
		this._reported = [];
	}

	_clearDOM() {
		while (this._contents.length) {
			this._contents.pop().destroy();
		}

		if (this._geometry) {
			this._geometryLayer.removeAll();
			this._geometry.destroy();
			this._geometry = null;

			Scene.removeLayer(this._geometryLayer);
			this._geometryLayer.destroy();
			this._geometryLayer = null;
		}

		this._wasmMarker?.destroy();
		this._wasmGeometry?.destroy();

		Mapy.Util.clear(this._dom.container);
		Mapy.Util.clear(this._dom.header);
	}

	/**
	 * Mame data pro vyrobu detailu
	 */
	_response(data: {
		poi: IPoi;
		status: number;
	}, status) {
		this._clearDOM();

		// skryti kapky
		this._drop.setPosition(null);

		if (!data.poi?.source || (status && status != 200 || data.status != 200)) {
			makeEvent("detail-error", this, data.status);

			if (data.status == 404 || data.status == 403) {
				Mapy.setPhantomMeta(404);
			}
			store.dispatch(unsetDetail());

			return;
		}

		this._postProcess(data);

		if (!["coor", "closure"].includes(data.poi.source)) {
			if (this._data.extend?.signs) {
				for (const sign of this._data.extend.signs) {
					this._wasmHiddenPois.addPoi(sign.source, sign.id);
				}
			} else {
				this._wasmHiddenPois.addPoi(data.poi.source, data.poi.id);
			}

			this._wasmHiddenPois.updateWasm();
		}

		parseGallery(this._data).then(galleryData => {
			const mapState = store.getState().map;

			this._galleryData = galleryData;

			if (this._data?.source !== "closure") {
				this.setSEO();
			}
			this._setPanoVisibility();
			this._setM3dAvail(mapState);
			this._setSuggest();
			this._buildDetail();

			if (this._data?.show) { /* pokud pozadovano, nastavit mapu */
				this._setCenterZoom();
			}

			var headline = node("h4", { className: "bp-detail" });
			headline.appendChild(JAK.ctext(getTitle(this._data, this._likeData)));
			Mapy.getComponent("layout").setBottomPanel(headline);

			this._buildModule();
			makeEvent("detail-activated", this);

			/* pokud je otevrena komponenta s webkamerou, pak se obnovujeme z URL a ona od nas potrebuje data */
			var webcam = Mapy.getComponent("webcam");
			if (webcam.isActive()) { this._activateWebcam(); }

			if (this._galleryData.webcam) {
				this._dom.webcam.style.display = "inline-block";
			} else {
				if (this._dom.webcam.parentNode) {
					this._dom.webcam.style.display = "";
				}
			}

			this._setMarkerAndAreaVisibility();

			if (CONFIG.wasmEnabled) {
				this._setWasmMarkerGeomVisibility(store.getState().map.zoom);
			}

			this._setDropVisibility();
		}, () => {});
	}

	_postProcess(dataIn: {
		poi: IPoi;
		status: number;
	}) {
		const data = dataIn.poi || {};

		// udelame z this._data objekt, protoze se muze stat, ze to je null, ale dal se pocita s tim, ze to je vzdy objekt
		if (!this._data) {
			this._data = {};
		}

		/* merge dat z poiserveru do naseho objektu */
		for (var p in data) {
			if (!(p in this._data)) { this._data[p] = data[p]; }
		}

		let joiner = ", ";

		this._data.title = this._data.titleVars.titleMain || this._data.title;
		this._data.titleSub = this._data.titleVars.titleSub || "";
		this._data.typeName = this._data.titleVars.specification || this._data.typeName;
		this._data.locationMain = this._data.titleVars.locationMain3.length ? this._data.titleVars.locationMain3.join(joiner) : "";
		this._data.locationSub = this._data.titleVars.locationSub3.length ? this._data.titleVars.locationSub3.join(joiner) : "";

		var x = this._data.mark.lon;
		var y = this._data.mark.lat;

		if ("mark" in this._data && !(this._data.coords && !this._data.useMark)) {
			this._data.coords = Scene.coordsFromWGS84(x, y);
		} else {
			this._data.origCoords = Scene.coordsFromWGS84(x, y);
		}
		this._data.panoCoords = this._data.extend.ref_pos ? Scene.coordsFromWGS84(this._data.extend.ref_pos.lon, this._data.extend.ref_pos.lat) : null;

		var type = (this._data.typeId || -1);
		var name = (getTitle(this._data, this._likeData) || "");

		var logger = Mapy.getComponent("logger");

		var detailLog = {
			source: this._data.source,
			id: this._data.id,
			typeid: type,
			name: name,
			poi_region_booking_offer: false,
		};

		const isFirm = isFirmFromPoi(this._data);
		let reviewConf = getReviewConf(this._data, this._likeData, this._reviewMode, this._drrid);
		let rating_layout = null;

		if (isFirm) {
			if (this._data.inactive) {
				rating_layout = 0;
			}
			else if (this._data.review) {
				rating_layout = getFirmLayout(reviewConf.review, reviewConf.booking, reviewConf.myReview, true);
			}
		}

		if (rating_layout !== null) {
			detailLog.rating_layout = rating_layout;
		}

		if (this._data.coords) {
			detailLog.x = this._data.coords.x;
			detailLog.y = this._data.coords.y;
		}

		detailLog.isAnonymized = !!this._data.anonymized;

		if (isFirm && this._data.review) {
			detailLog.owner = !(this._data.admin_urls && this._data.admin_urls.regflow) ? 1 : 0;
		}

		//booking
		if (this._data.extend.poi.booking) {
			if (this._data.extend.poi.booking.url_accommodation_type) { // pro firm
				detailLog.source_import = this._data.extend.poi.booking.url_accommodation_type === "booking" ? "Booking" : "Firmy";
			} else { // pro som
				detailLog.source_import = "Booking";
			}
		}

		// hledame hlasenou chybu, tak si podezrele veci budeme logovat
		if (Array.isArray(detailLog.id)) {
			Sentry.withScope(scope => {
				scope.setTag("detail_id", detailLog.id.toString());
				Sentry.captureException(new Error("DetailIDError"));
			});
		}

		this._bookingLinkProm = deferPromise();

		// nacteme booking link
		getBookingLink({
			source: this._data.source,
			origin: this._data.origin,
			lon: this._data.mark.lon,
			lat: this._data.mark.lat,
		}).then(bookingLinkData => {
			detailLog.poi_region_booking_offer = bookingLinkData.link !== "";
			logger.log("detail", detailLog);
			this._bookingLinkProm?.resolve(bookingLinkData);
		}, errData => {
			logger.log("detail", detailLog);
			this._bookingLinkProm?.reject(errData);
		});

		if (rating_layout !== null) {
			logger.log("ratingShow", { type: rating_layout });
		}

		if ("pp_gemius_hit" in window) {
			pp_gemius_hit(PP_GEMIUS_IDENTIFIER, ["gA=mapy.cz/mapy.cz/detail"]);
		}

		if (isFirm) {
			if (this._data.stats) {
				this.sendFirmStats("open", data, { placeId: 1 });
			}
		} else {
			logger.log("impress");
		}

		if (this._data.source == "closure" || this._data.source == "bs") {
			this._data.extend.map = {
				center: this._data.coords,
				source: this._data.source,
			};
		}
	}

	_buildDetail() {
		if (!this._data) {
			return;
		}

		const isWindyWebcam = !!this._data.extend?.webcamData;

		this._poster = this._buildContent(Poster, this._data.source);

		if (this._data.source !== "di" && this._data.source !== "closure" && this._data.source !== "bs") {
			const placeholder = new PlaceholderImage(this._data);

			this._posterContents.placeholder = placeholder;
			this._contents.push(placeholder);

			if (this._galleryData.preferWebcam) {
				const webcam = new WebCam({
					webcam: this._galleryData.webcam,
					id: this._data.id,
					source: this._data.source,
					title: getTitle(this._data, this._likeData),
				});

				this._posterContents.webcam = webcam;
				this._contents.push(webcam);
			}

			if (this._data.extend?.video) {
				const video = new Video(this._data.extend.video);

				this._posterContents.video = video;
				this._contents.push(video);
			}

			if (isWindyWebcam) {
				const windyWebCam = new WindyWebCam(this._data.extend.webcamData);

				this._posterContents.windyWebCam = windyWebCam;
				this._contents.push(windyWebCam);
			}
		}

		if (this._galleryData.best && !isWindyWebcam) {
			const bestImage = new BestImage({
				best: this._galleryData.best,
				isBooking: !!this._data.extend?.poi?.booking,
				id: this._data.id,
				source: this._data.source,
			});

			this._posterContents.bestImage = bestImage;
			this._contents.push(bestImage);
		}

		switch (this._data.source) {
			case "foto":
			case "ffoto":
				this._buildContentsPhotoPoi();
				break;

			default:
				this._buildContentsDefault();
				break;
		}

		if (this._data.openReviewPopup) {
			delete this._data.openReviewPopup;
		}

		if (this._data.source != "closure" && this._data.source != "bs") {
			this._poster.addPosterData([
				{ obj: this._posterContents.placeholder },
				{ obj: this._posterContents.webcam },
				{ obj: this._posterContents.video },
				{ obj: this._posterContents.bestImage },
				{ obj: this, getData: "getPanoPosterData" },
				{ obj: this._posterContents.map },
				{ obj: this._posterContents.photo },
				{ obj: this._posterContents.windyWebCam },
			]);
		} else {
			this._poster.addPosterData([
				{ obj: this._posterContents.map },
			]);
		}

		if (this._data.source == "addr") {
			this._buildContent(AtAddress, this._data);
		}

		this._dom.container.appendChild(this._dom.modules);

		if (this._data.extend.poi.commercial) {
			const commercialContainer = node("div", { className: "detail__commercial-collaboration" });

			commercialContainer.appendChild(createCommercialCollaboration({ align: "right" }));
			this._dom.header.insertBefore(commercialContainer, this._dom.header.firstChild);
		}
		this._dom.header.insertBefore(this._dom.btnContainer, this._dom.header.firstChild);
		this._dom.container.insertBefore(this._dom.btnContainerBack, this._dom.header);
		//this._dom.comm.style.display = !this._data.extend.poi.commercial ? "none" : "";

		if ((!this._data.review || this._data.inactive || this._data.rusAdmin) && this._immediatelyOpenReview) {
			Notifications.notify({
				content: _("detail.cannotStartReview"),
				type: NOTIFICATIONS_TYPE.ERROR,
			});
		}

		this._buildMarker();
		this._buildGeometry();
	}

	_buildContentsPhotoPoi() {
		var data;
		//fotka
		var photo = new BestImage({
			best: this._data.gallery[0].media[0],
			id: this._data.id,
			source: this._data.source
		});
		this._posterContents.bestImage = photo;
		this._contents.push(photo);

		this._dom.container.appendChild(this._dom.header);

		// titulek
		if (getTitle(this._data, this._likeData)) {
			data = {
				title: getTitle(this._data, this._likeData)
			};
			this._buildContent(Title, data, undefined, this._dom.header);
			data = null;
		}

		this._buildContent(Media, this._galleryData.gallery, {
			detail: this._data,
			placeholder: this._dom.galleryPlaceholder,
			preferWebcam: this._galleryData.preferWebcam
		});

		// nove akce misto modulu
		var contentActions = node("div", { className: "clear-content actions" });
		contentActions.appendChild(this._actions.share.container);
		contentActions.appendChild(this._actions.report.container);
		this._dom.header.appendChild(contentActions);

		var photoData = this._data.gallery[0];
		//autor fotky
		if (photoData.media.length && photoData.media[0].authorName) {
			this._buildContent(PhotoAuthor, photoData.media[0]);
		}

		// datum porizeni, pokud je k dispozici a neni uz v EXIF datech
		var exifs = [];
		for (var info in this._data.exif) {
			exifs.push(this._data.exif[info].name);
		}
		if (!exifs.some(function(item) { return DATE_TAGS.indexOf(item) != -1 }) && photoData.media[0].takeDate) {
			this._buildContent(TakeDate, photoData.media[0].takeDate);
		}
		else if (photoData.media[0].createDate) {
			this._buildContent(TakeDate, photoData.media[0].createDate);
		}

		// description
		this._buildContentIf(Description, this._data.desc || this._data.description);

		// exif data
		this._buildContentIf(EXIF, this._data.exif);
	}

	_buildContentsDefault() {
		if (this._data.extend.photo) {
			var photo = new Photo({
				best: this._galleryData.best,
				href: this._data.extend.photo.href
			});
			this._posterContents.photo = photo;
			this._contents.push(photo);
		}

		if (this._data.extend.map && !this._galleryData.best) { //traffic
			var traficMap = new SmallMap(this._data.extend.map);
			this._posterContents.map = traficMap;
			this._contents.push(traficMap);
		}

		this._dom.container.appendChild(this._dom.header);
		this._buildContentIf(Title, {
			title: getTitle(this._data, this._likeData),
			origTitle: this._data.title,
			source: this._data.source,
			coords: this._data.coords,
			likeData: this._likeData,
			onUpdate: newLikeData => {
				Object.assign(this._likeData, newLikeData);
			},
		}, undefined, this._dom.header);
		this._buildContentIf(SubTitle, {
			data: this._data,
			coords: this._data.coords,
			userTitle: this._likeData ? this._likeData.usertitle : null,
			origTitle: this._data.title
		}, undefined, this._dom.header);
		this._buildContentIf(TypeName, { typeName: this._data.typeName, source: this._data.source, typeNameSearchable: NON_REPORTED_POITYPES.indexOf(this._data.typeId) === -1 ? this._data.typeNameSearchable : false }, undefined, this._dom.header);
		this._buildContentIf(PhotoAuthor, this._data.extend.photo, undefined, this._dom.header); /* fotopoi */
		this._buildContentIf(Address, this._data, undefined, this._dom.header);
		this._buildContent(ReportLocalChanges, this._data, undefined, this._dom.header);

		if (this._data.source === "di") {
			this._buildContentIf(DiInfo, this._data, undefined, this._dom.header);
		}

		this._buildContentIf(ManageMyCompany, isOwner(this._data), undefined, this._dom.header);

		// nove akce misto modulu
		var contentActions = node("div", { className: "clear-content actions" });
		if (this._data.source === "di" || this._data.source === "bs") {
			contentActions.appendChild(this._actions.share.container);
		} else if (this._data.source == "foto" || this._data.source == "ffoto") {
			contentActions.appendChild(this._actions.share.container);
			contentActions.appendChild(this._actions.report.container);
		} else {
			this._actions.route.props = Object.assign({}, this._actions.route.props, {
				href: new SMap.URL.Route(`https://${CONFIG.BASE_URL}`).addDestination(this._data.coords, {
					poi: [this._data.source, this._data.id]
				}).toString()
			});
			contentActions.appendChild(this._actions.route.container);
			contentActions.appendChild(this._actions.save.container);
			contentActions.appendChild(this._actions.share.container);
			contentActions.appendChild(this._actions.triptips.container);
		}
		if (this._data.source != "closure") {
			this._dom.header.appendChild(contentActions);
		}

		this._buildContentIf(MymapsPlace, { data: this._data, likeData: this._likeData || isPoiSaved(this._data.source, this._data.id) });
		this._buildContent(BookingLink, { data: this._data, linkProm: this._bookingLinkProm });

		if (this._data.extend.poi.booking) {
			const linkTest = !(this._data.extend.link || this._data.extend.urls);
			const reviewConf = getReviewConf(this._data, this._likeData, this._reviewMode, this._drrid, this._immediatelyOpenReview, this._openReviewData);
			const commentsTest = reviewConf.review?.total > 0;

			this._buildContent(Review, JSON.parse(JSON.stringify(reviewConf)));
			this._buildContentIf(Opening, this._data.extend.opening, { log: this._log, data: this._data });
			this._buildContentIf(Contact, this._data.extend.contact || this._data.anonymized, { source: this._data.source, id: this._data.id, isPaid: "paid" in this._data, noContact: !!this._data.anonymized });
			this._buildContentIf(Report, reportPoiType(this._data.typeId) && !isOwner(this._data) ? { data: this._data } : null);
			this._buildContent(WeatherContent, this._data);
			this._buildContentIf(HotelClass, this._data.extend.poi.booking.class);
			this._buildContentIf(HotelGallery, this._galleryData ? this._galleryData.gallery : null, { source: this._data.source, id: this._data.id, title: getTitle(this._data, this._likeData) });
			this._buildContentIf(HotelCheck, this._data.extend.poi.booking.url, Object.assign({}, this._data, { title: getTitle(this._data, this._likeData) }));
			this._buildContentIf(HotelDesc, this._data.description); // tohle se musi zmenit, az dojdeme k desc misto description (samotne description s tim pocita, ale tohle druhe ne)
			this._buildContentIf(KeyValueTags, this._data.extend.poi?.keyval_tags, { data: this._data });
			this._buildContent(POILink, this._data.poilink, { type: "twin" });
			commentsTest && this._buildContentIf(News, this._data.showNews, { data: this._data });
			linkTest && this._buildContent(Comments, JSON.parse(JSON.stringify(reviewConf)), { data: this._data });
			this._buildContentIf(TableReservation, this._data.urlDetailReservation, this._data);
			this._buildContentIf(Offers, {
				offers: this._data.offers,
				actualOffers: this._data.actualOffers,
				title: this._data.title,
				stats: this._data.stats,
				id: this._data.id
			});
			if (!this._data.offers?.result?.length) {
				this._buildContentIf(Services, this._data.marketOffers, {
					title: this._data.title,
					stats: this._data.stats,
					id: this._data.id,
					inactive: !!this._data.inactive,
				});
			}
			this._buildContentIf(Leaflets, this._data.actualOffers, {
				source: this._data.source,
				id: this._data.id,
				typeid: this._data.typeId || -1,
				title: getTitle(this._data, this._likeData),
				detailData: this._data,
			});
			this._buildContent(Media, this._galleryData.gallery, {
				detail: this._data,
				placeholder: this._dom.galleryPlaceholder,
				preferWebcam: this._galleryData.preferWebcam
			});
			!linkTest && this._buildContent(Comments, JSON.parse(JSON.stringify(reviewConf)), { data: this._data });
			this._buildContentIf(Link, this._data.extend.link || this._data.extend.urls, { urls: this._data.extend.urls });
			!commentsTest && this._buildContentIf(News, this._data.showNews, { data: this._data });
			this._buildContent(DetailPoisContent, this._data);
			this._buildContentIf(EstateLink, this._data);
			this._buildContent(POILink, this._data.poilink, { type: "", detailData: this._data });
			this._buildContentIf(Partner, this._data.extend.partner, { data: this._data });
		} else if (this._data.source != "closure") {
			const linkTest = !this._data.extend.admission && !this._data.extend.keyvalue && !this._data.extend.poi?.keyval && !(this._data.extend.link || this._data.extend.urls);
			const reviewConf = getReviewConf(this._data, this._likeData, this._reviewMode, this._drrid, this._immediatelyOpenReview, this._openReviewData);
			const commentsTest = reviewConf.review?.total > 0;

			this._data.review && this._buildContent(Review, JSON.parse(JSON.stringify(reviewConf)));
			// groomer
			this._buildContentIf(Groomer, this._data.extend.groom);
			this._buildContentIf(Inaccurate, this._data.mark.inaccurate);
			if (!this._data.inactive) {
				this._buildContentIf(Opening, this._data.extend.opening, { source: this._data.source, log: this._log, data: this._data });
				this._buildContentIf(Opening, this._data.extend.closure, { source: this._data.source, log: this._log, data: this._data });
			} else {
				this._buildContentIf(Inactive, this._data.inactive, {
					inactive: this._data.inactive,
					temporarilyClosed: this._data.temporarilyClosed,
				});
				this._buildContentIf(Report, reportPoiType(this._data.typeId) && !isOwner(this._data) ? { data: this._data } : null);
			}
			this._buildContentIf(Contact, this._data.extend.contact || this._data.anonymized || this._data.inactive, {
				source: this._data.source,
				id: this._data.id,
				isPaid: "paid" in this._data,
				noContact: !!this._data.anonymized,
				inactive: this._data.inactive,
				temporarilyClosed: this._data.temporarilyClosed,
			});
			if (!this._data.inactive) {
				this._buildContentIf(Report, reportPoiType(this._data.typeId) && !isOwner(this._data) ? { data: this._data } : null);
			}
			this._buildContent(WeatherContent, this._data);
			this._buildContentIf(TableReservation, this._data.urlDetailReservation, this._data);
			this._buildContentIf(Offers, {
				offers: this._data.offers,
				actualOffers: this._data.actualOffers,
				title: this._data.title,
				stats: this._data.stats,
				id: this._data.id
			});
			if (!this._data.offers?.result?.length) {
				this._buildContentIf(Services, this._data.marketOffers, {
					title: this._data.title,
					stats: this._data.stats,
					id: this._data.id,
					inactive: !!this._data.inactive,
				});
			}
			this._buildContentIf(Leaflets, this._data.actualOffers, {
				source: this._data.source,
				id: this._data.id,
				typeid: this._data.typeId || -1,
				title: getTitle(this._data, this._likeData),
				detailData: this._data,
			});

			this._buildContentIf(Fuel, this._data.extend.fuel);

			var transportOptions = {
				id: [this._data.id],
				typeId: this._data.typeId,
				typeName: this._data.typeName,
				title: this._data.title,
				station: this._data.extend.station
			};
			this._buildContentIf(Signs, this._data.extend.signs, transportOptions);
			this._buildContentIf(TransportLines, this._data.extend.transportlines, transportOptions);
			this._buildContentIf(Lifetime, this._data.extend.lifetime, { updated: false });
			if (this._data.source == "di" && this._data.extend.feedbackEnabled) {
				this._buildContentIf(Feedback, {
					id: this._data.id,
					source: this._data.source,
					title: this._data.title,
				});
			}
			this._buildContentIf(Description, this._data.desc || this._data.description, {
				lang: this._data.descriptionLang || Mapy.CUS.userweb.deeplLang || CONFIG.defaultLang,
			});
			this._buildContent(POILink, this._data.poilink, { type: "twin" });
			linkTest && this._buildContent(Comments, JSON.parse(JSON.stringify(reviewConf)), { data: this._data });
			this._buildContentIf(Lifetime, this._data.extend.lifetime, { updated: true });
			this._buildContentIf(Place, this._data.extend.place);
			this._buildContentIf(Admission, this._data.extend.admission); /* FIXME zrusit nebo pouzit price */
			this._buildContentIf(Parking, this._data.extend.parking);
			this._buildContentIf(Price, this._data.extend.price);
			this._buildContentIf(KeyValueTags, this._data.extend.poi?.keyval_tags, { data: this._data });
			this._buildContentIf(KeyValue, this._data.extend.keyvalue);
			this._buildContentIf(KeyVal, this._data.extend?.poi?.keyval);
			commentsTest && this._buildContentIf(News, this._data.showNews, { data: this._data });
			this._buildContentIf(InfoLinks, this._data.infolinks);
			this._buildContent(Media, this._galleryData.gallery, {
				detail: this._data,
				placeholder: this._dom.galleryPlaceholder,
				preferWebcam: this._galleryData.preferWebcam
			});
			!linkTest && this._buildContent(Comments, JSON.parse(JSON.stringify(reviewConf)),  { data: this._data });
			this._buildContentIf(Link, this._data.extend.link || this._data.extend.urls, { urls: this._data.extend.urls });
			!commentsTest && this._buildContentIf(News, this._data.showNews, { data: this._data });
			this._buildContent(DetailPoisContent, this._data);
			this._buildContentIf(EstateLink, this._data);
			this._buildContent(POILink, this._data.poilink, { type: "", detailData: this._data });
			this._buildContentIf(Partner, this._data.extend.partner, { data: this._data });
		}
		else if (this._data.source == "closure") {
			this._buildContentIf(Description, this._data.desc || this._data.description);
		}
		// snezeni
		this._buildContentIf(Snow, this._data);
	}

	_buildContentIf(content, data, options, parent) {
		if (!data) { return; }
		this._buildContent(content, data, options, parent);
	}

	_buildContent(content, data, options, parent) {
		var inst = new content(data, options);
		this._contents.push(inst);
		(parent || this._dom.container).appendChild(inst.getContainer());

		return inst;
	}

	_isPanoReady(coords, regionEntityType, geom, source) {
		if (!coords) {
			return false;
		}

		const allowed = ["addr", "stre", "quar", "ward", "muni"];
		// navazane na nejakou entitu z vyctu allowed
		const wgsCoords = coords.toWGS84();
		const czechiaBbox = SceneConst.statesArea.cs.bbox;

		/**
		 * nesmi byt geometrie - nebo je geometrie, ale jsme v poli allowed nebo regionEntityType je v poli allowed
		 * jako bonus musime byt v CR
		 */
		return (!geom
			|| allowed.indexOf(source) !== -1
			|| regionEntityType && allowed.indexOf(regionEntityType) !== -1)
			&& wgsCoords[0] >= czechiaBbox[0] && wgsCoords[0] <= czechiaBbox[1] && wgsCoords[1] >= czechiaBbox[2] && wgsCoords[1] <= czechiaBbox[3];
	}

	_setPanoVisibility() {
		this._panoPromise = new JAK.Promise();

		if (!this._data) {
			this._panoPromise.reject();

			return;
		}

		// skryjeme pano by default
		this._dom.pano.style.display = "";

		const coords = this._data.panoCoords || this._data.coords;

		if (this._isPanoReady(coords, this._data.regionEntityType, this._data.geom, this._data.source)) {
			const wgs84 = coords.toWGS84();

			getPanoAtCoords({
				lon: wgs84[0],
				lat: wgs84[1],
			}).then(place => {
				this._panoAvailable(place);
			}, () => {
				this._panoUnavailable();
			});
		} else {
			// pokud panorama vubec nebudeme zkouset nacist, tak pro jistotu rejectneme promise, kdyby na nej nekdo nekde cekal
			this._panoPromise.reject();
		}
	}

	_setM3dAvail(state: IMapState) {
		const { mapset: seo } = state;
		const mapset = getMapsetBySEO(seo);

		this._dom.m3d.style.display = mapset && isM3dAvailable(mapset.id) ? "inline-block" : "";
	}

	_panoAvailable(place) {
		if (this._data) {
			this._dom.panoHref = node("a", { href: "#" });
			this._dom.panoHref.classList.add("pano-cover");

			if (PanoUtils.isSupported()) {
				this._dom.panoHref.addEventListener("click", this, false);
			}

			var size = getDetailSize();
			var panoImg = new Mapy.Pano.Image(place, this._data.coords, {
				width: size.width,
				height: size.height
			});

			this._panoImg = panoImg;
			this._panoPromise.fulfill([this._dom.panoHref, "pano", panoImg]);
			this._place = place;
			this._dom.pano.style.display = "inline-block";
			if (!this._galleryData.preferWebcam) {
				this._contents.forEach(function(content) {
					if (content instanceof Media) {
						content.addUploadBox();
					}
				});
			}

		}
	}

	_panoUnavailable() {
		this._place = null;
		this._dom.pano.style.display = "";
		this._panoPromise.reject();
	}

	async _preActivatePanorama() {
		if (!Scene.isMapActive()) {
			try {
				await Scene.setActive("map");
			} catch (exc) {
				/* eslint-disable-next-line */
				console.log(exc);
			}
		}

		this._activatePanorama();
		Mapy.getComponent("history").save();
	}

	_activatePanorama() {
		if (!this._place || !this._data) {
			return;
		}

		var state = {
			pid: this._place.getId()
		};

		var params = this._panoImg ? this._panoImg.getParams() : null;

		if (params) {
			state.yaw = parseFloat(params.yaw);
			state.pitch = params.pitch;
			state.fov = params.fov;
		} else {
			var yaw = "auto";
			const placeCoords = this._place.getCoords();
			const coords = Scene.coordsFromWGS84(placeCoords[0], placeCoords[1]);
			var azimuth = coords.azimuth(this._data.coords);

			yaw = azimuth * Math.PI / 180;

			state.yaw = yaw;
		}

		Mapy.getComponent("pano").activate().setState(state);
	}

	_activateWebcam() {
		if (this._galleryData.webcam) {
			Mapy.getComponent("webcam").activate().setData(this._galleryData.webcam, getTitle(this._data, this._likeData));
		}
	}

	_buildActionData() {
		var data = {
			source: this._data.source,
			source_id: this._data.id,
			title: Mapy.Util.decodeEntities(getTitle(this._data, this._likeData)),
			subtitle: this._data.typeName || "",
			coords: this._data.coords,
		};

		// adresa jako subtitle
		if (this._data.locationMain) {
			data.subtitle = this._data.locationMain;
		}

		if (this._likeData) {
			if ("usertitle" in this._likeData) {
				data.usertitle = this._likeData.usertitle;
			}

			if (this._likeData.description) {
				data.description = this._likeData.description;
			}
		}

		return data;
	}

	_buildMarker() {
		if (this._marker) {
			this.setMarkerVisibility();
			this._marker.destroy();
		}

		if (this._wasmMarker) {
			this._wasmMarker.destroy();
		}

		var favicon = "";
		var elm = null;

		if ("markerIcon" in this._data && this._data.markerIcon != "") {
			elm = icon(this._data.markerIcon);
		}
		else if ("icon" in this._data) {
			for (var p in this._data.icon) {
				favicon = this._data.icon[p];
			}
		}

		let options = {
			fromMarker: this._data.fromMarker,
			icon: favicon,
			elm: elm,
			m3dData: {
				type: "detail"
			}
		}

		if (this._showLabel) {
			options.type = Scene.VISUAL.MARKER_WINDY.LITTLE;
			options.elm = null;
			options.icon = null;
		}

		if (this._likeData && this._likeData.usertitle !== "") {
			options.usertitle = this._likeData.usertitle || this._likeData.title;
		}

		const markerImg = getMarkerImgFrompoi(this._data);

		this._marker = Scene.createMarkerMapyWindyDetailFromPOI(this._data, undefined, options);
		this._wasmMarker = new WasmStoreMarker({
			type: !markerImg || ["coor", "closure"].includes(this._data.source) ? "big-universal" : "big",
			lon: this._data.mark.lon,
			lat: this._data.mark.lat,
			visible: false,
			zIndex: WASM_ZINDEX.marker.poiDetail,
			customData: {
				url: markerImg,
				caption: this._likeData
					? this._likeData.usertitle || this._likeData.title
					: this._data.title,
				...this._data.review && reviewHasColoredBadge(this._data.review)
					? {
						review: {
							active: reviewHasGreenBadge(this._data.review),
							value: this._data.review.review_rating_stars,
						},
					}
					: {},
			},
			interactionType: "hover",
		});
		this.setMarkerVisibility(this._data.source != "pubt"); /* zastavky si samy ridi zvyrazneni v mape v Signs */

		if (this._showLabel) {
			this._marker.setLabel(this._showLabel === 1 ? this._likeData.usertitle : this._likeData.usertitle || this._likeData.title);
		}
	}

	_buildGeometry() {
		// zde je dulezite, aby to zustala reference a nebyla kopie
		var g = this._data.geom;

		if (!g || !g.type || g.type == "multipoint") { return; }

		this._geometryLayer = Scene.createLayerGeometry("detail-geom");

		/* polygony maji special vzhled */
		if (g.type.indexOf("polygon") > -1) {
			g.style = {
				width: 3,
				opacity: 1,
				style: 0,
				color: "red",
				outlineWidth: 3,
				outlineStyle: JAK.Vector.STYLE_SOLID,
				outlineColor: "white",
				outlineOpacity: 1
				/*opacity: 1,
				style: 7,
				color: "none",
				outlineWidth: 3,
				outlineStyle:JAK.Vector.STYLE_SOLID*/
			};
		}

		// bile stopy maji extra vzhled
		if (this._data.source === "bs") {
			const colors = {
				"1": "#9C0A50",
				"3": "#E8378C",
				"7": "#DEA2BF",
				"-1": "#426DD2",
			};
			g.style = {
				width: 6,
				opacity: 1,
				style: JAK.Vector.STYLE_SOLID,
				color: colors[this._data.extend.groom && this._data.extend.groom.age ? this._data.extend.groom.age : "-7"],
				outlineWidth: 2,
				outlineStyle: JAK.Vector.STYLE_SOLID,
				outlineColor: "white",
				outlineOpacity: 0.6,
			};
		}

		this._geometry = Scene.createGeometrySmartMulti(this._data);
		this._wasmGeometry = new WasmStoreGeometry({
			type: "poi-geom",
			strPoints: this._data.geom.data,
			zIndex: WASM_ZINDEX.geometry.poiDetail,
		});

		if (this._geometry.visible) {
			if (CONFIG.inFrame) {
				this._geometryLayer.addEventListener("click", e => {
					Mapy.Util.openInNewWindow();
				});
			}
			else {
				this._geometry.disableClick();
			}
			this._geometryLayer.addSmartGeometry(this._geometry);
		}

		// skryjeme geometrii by default
		this._geometryLayer.setStyle("visibility", "hidden");

		Scene.addLayer(this._geometryLayer).enable();

		const wt = watch(store.getState, "map", watchAnimation);

		this._storeAnimationUnsubscribe = store.subscribe(wt((newMap, oldMap) => {
			this._setMarkerAndAreaVisibility(newMap.animating);
		}));

		if (CONFIG.wasmEnabled) {
			const wt2 = watch(store.getState, "map", watchMapZoom);

			this._storeZoomUnsubscribe = store.subscribe(wt2((newMap, oldMap) => {
				this._setWasmMarkerGeomVisibility(newMap.zoom);
			}));
		}
	}

	/**
	 * append modulu
	 */
	_buildModule() {
		var m = this._dom.modules;
		if (this._gps) {
			this._gps.container.remove();
			this._gps.destroy();
		}
		Mapy.Util.clear(m);
		this._gps = new GPSSwitch();
		this._gps.coords = this._data.coords;
		this._gps.visualization = "select";
		this._dom.modulesInner.appendChild(this._gps.container);
		m.appendChild(this._dom.modulesInner);
	}

	_setCenterZoom() {
		if (this._geometry && this._geometry.getCoords().length) { /* vzit center/zoom z geometrie */
			var cz = this._geometry.computeCenterZoom(true);
			if (cz[1] == Infinity) { cz[1] = 17; } /* pokud je geometrie bodova */
		} else { /* vzit center/zoom z marku a sourcu */
			var cz = [this._data.coords, Mapy.Util.computeZoom(this._data)];

			if (this._data.show && this._data.show.z) {
				cz[1] = parseInt(this._data.show.z);
			}
		}

		// specialni misto pro ukladani, kdy detail je specialni pripad, pac si nastavuje pozici mapy sam a posun muze byt animovan
		// FIXME: tohle by nemel delat detail, ale Scene sama v sobe v reakci na otevreni a nacteni detailu
		if (Scene.isM3dActive()) {
			const defaultYaw = 0;
			const defaultPitch = -45;
			const { yaw, pitch } = store.getState().map;

			Scene.providers.m3d.setPosition({
				x: cz[0].x,
				y: cz[0].y,
				mercZ: cz[1] + 1,
				yaw: CONFIG.inFrame ? yaw || defaultYaw : defaultYaw,
				pitch: CONFIG.inFrame ? pitch || defaultPitch : defaultPitch,
			});
		} else {
			const [longitude, latitude] = cz[0].toWGS84();
			const { zoom } = store.getState().map;

			store.dispatch(setCoordinates({
				longitude,
				latitude,
				zoom: cz[1],
				animate: cz[1] <= zoom + 1 && cz[1] >= zoom - 1,
			}));
		}
	}

	/**
	 * Logika pro skryvani/odkryvani markeru a oblasti
	 * @param {Bool} [hide] Skryt oblast a marker pro detail?
	 */
	_setMarkerAndAreaVisibility(hide) {
		var hiddenStyle = "hidden";

		if (this._geometryLayer && this._geometry.visible) {
			var bbox = this._geometry.getBBox();
			var bboxArea = bbox.width * bbox.height;
			const { zoom } = store.getState().map;
			var toggelClass = hide => {
				this._marker.getContainer(el => {
					el.classList[hide ? "add" : "remove"]("hidden");
				});
			};

			toggelClass(false);

			if (hide) {
				this._marker.setStyle("visibility", hiddenStyle);
				this._geometryLayer.setStyle("visibility", hiddenStyle);
			}
			else if (bbox.width != 0 && bbox.height != 0) {
				var size = Math.max(bbox.width, bbox.height);
				// zobrazit znacku i geometrii
				if (zoom > 15 && bboxArea < 30 * 30 && size < 30) {
					// mala area - marker
					this._marker.setStyle("visibility", "");
					this._geometryLayer.setStyle("visibility", "");
				}
				// testovaci oblast vuci konstante 70x70 (sirka a vyska); a zoom mensi jak 16
				else if (zoom < 16 && bboxArea < 70 * 70 && size < 70) {
					// mala area - marker
					this._marker.setStyle("visibility", "");
					this._geometryLayer.setStyle("visibility", hiddenStyle);
				}
				else {
					// velka area - zobrazime oblast
					this._marker.setStyle("visibility", hiddenStyle);
					toggelClass(true);
					this._geometryLayer.setStyle("visibility", "");
				}
			}
			else {
				var size = Math.max(bbox.width, bbox.height);
				if (zoom > 15 && size < 30) {
					// mala area - marker
					this._marker.setStyle("visibility", "");
					this._geometryLayer.setStyle("visibility", "");
				}
				// testovaci oblast vuci konstante 70x70 (sirka a vyska); a zoom mensi jak 16
				else if (zoom < 16 && size < 70) {
					// mala area - marker
					this._marker.setStyle("visibility", "");
					this._geometryLayer.setStyle("visibility", hiddenStyle);
				}
				else {
					// velka area - zobrazime oblast
					this._marker.setStyle("visibility", hiddenStyle);
					toggelClass(true);
					this._geometryLayer.setStyle("visibility", "");
				}
			}
		}
		else {
			this._marker.setStyle("visibility", "");
		}
	}

	_setDropVisibility() {
		if (this._data?.coords && ((this._geometry && !this._geometry.isGeometryVisible()) || !this._geometry)) {
			// kapka pro detail
			this._drop.setPosition(this._data
				? () => {
					const { longitude, latitude } = store.getState().map;

					return {
						position: getPointerCenterPx(this._data.coords),
						caption: getPointerDistance(Scene.coordsFromWGS84(longitude, latitude), this._data.coords),
					}
				}
				: null);
		} else {
			this._drop.setPosition(null);
		}
	}

	_mapRedraw() {
		this._setDropVisibility();
	}

	_markerClick(e) {
		//FIXME pokud je otevreny imageuploader ma to tak zustat
		if (Mapy.getComponent("imageUploader").isActive()) {
			return;
		}

		if (e.target == this._marker) { // zkontrolujeme zda se jedna o nas marker
			if (CONFIG.inFrame) {
				Mapy.Util.openInNewWindow();
			}
			else {
				// komponenty, ktere se maji zavrit, pokud jsou aktivni a bylo kliknuto na detailovy marker
				if (Mapy.active[0] instanceof ContentFull) {
					Mapy.active[0].deactivate();
					//Mapy.getComponent("history").save();
				}
			}
		}
	}

	_printPage() {
		const state = store.getState();

		if (!isDetailActive(state) || !isPhotoDetail(state)) {
			return;
		}

		this._printPromise = Mapy.Util.createPrintPromise();
		Mapy.getComponent("print").addDepends(this._printPromise);
		if ("best" in this._galleryData && this._galleryData.best.urls.default) {
			this._bigImage = node("img", { className: "big-print-image", crossOrigin: "anonymous" });
			this._bigImage.src = Mapy.CDN.setSize(this._data.gallery[0].media[0].urls["default"], Mapy.CDN.SIZE_667_500);
			this._bigImage.addEventListener("load", this._resolvePrint.bind(this));
			this._bigImage.addEventListener("error", this._resolvePrint.bind(this));
		} else {
			this._printPromise.resolve();
		}
	}

	_printDone() {
		const state = store.getState();

		if (!isDetailActive(state) || !isPhotoDetail(state)) {
			return;
		}

		this._printPromise = null;
		//dát pryč z domu velkej obrázek
		if (this._bigImage) {
			this._bigImage.remove();
			this._bigImage = null;
		}
	}

	_resolvePrint(e) {
		if (e.type == "load") {
			this._poster.getContainer().appendChild(this._bigImage);
		}
		this._bigImage.removeEventListener("load", this._resolvePrint.bind(this));
		this._bigImage.removeEventListener("error", this._resolvePrint.bind(this));
		this._printPromise.resolve();
	}

	_rebuildDetail() {
		if (this._dataPromise) {
			JAK.Promise.all([this._dataPromise]).then(function() {
				while (this._contents.length) {
					this._contents.pop().destroy();
				}

				Mapy.Util.clear(this._dom.container);
				Mapy.Util.clear(this._dom.header);

				if (this._geometry) {
					this._geometryLayer.removeAll();
					this._geometry.destroy();
					this._geometry = null;

					Scene.removeLayer(this._geometryLayer);
					this._geometryLayer.destroy();
					this._geometryLayer = null;
				}

				this._wasmMarker?.destroy();
				this._wasmGeometry?.destroy();

				this._storeAnimationUnsubscribe?.();
				this._storeAnimationUnsubscribe = null;
				this._storeZoomUnsubscribe?.();
				this._storeZoomUnsubscribe = null;
				this.setMarkerVisibility(false);
				this._poster = null;
				this._posterContents = {};
				this._reported = [];
				this._setSuggest();
				this._buildDetail();
			}.bind(this), () => {});
		}
	}

	_getSearchForm() {
		const searchComp = Mapy.getComponent("search");
		const searchCb = data => {
			if (!data.query) return;

			searchForm.setLoading(true);
			searchForm.clearSuggestItems();
			searchForm.closeSuggest();
			searchComp.disablePanelLoad = false;
			searchComp.search({
				query: data.query,
				detailSearch: true,
				searchOrigin: "search",
			}).then(searchData => {
				searchForm.setLoading();

				if (searchData?.type != "detail") {
					store.dispatch(unsetDetail());
				}
			}, () => {
				searchForm.setLoading();
			});
			Mapy.getComponent("history").save();
		};

		const searchForm = new Form({
			// data { query }
			onFormSend: data => searchCb(data),
			// data { query, fromHistory, listCategory, noCorr }
			onFormSearch: data => {
				searchComp.disablePanelLoad = false;
				store.dispatch(unsetDetail());
				searchComp.search(data);
				Mapy.getComponent("history").save();
			},
			onFormClear: () => {
				searchComp.disablePanelLoad = false;
				searchComp.clearAll();
				store.dispatch(unsetDetail());
				searchComp.activate();
				Mapy.getComponent("history").save();
			},
			onArrowBack: () => {
				store.dispatch(unsetDetail());
				Mapy.getComponent("history").save();
			},
			// data { query, suggestData, results }
			onSuggest: data => {
				searchComp.disablePanelLoad = false;
				//store.dispatch(unsetDetail());

				const { query, suggestData, results, resultsType } = data;
				// analytika pro suggest
				logSuggestSearchSelection(suggestData, results, resultsType, "detail");
				// nastavime analytiku hledani
				//searchComp.setLoggerData(query, null, suggestData);
				searchComp.setState({
					q: data.query,
					fromTips: data.fromTips,
					cat: data.cat,
					detailSearch: true,
					searchOrigin: "suggestion",
				});
				searchComp.noResultAction = true;
			},
			// data { query }
			onSuggestEnter: data => searchCb(data),
			// data { title, query, fromTips, cat }
			onFixedSuggestSearch: data => {
				searchComp.disablePanelLoad = false;
				//store.dispatch(unsetDetail());
				searchComp.setState({
					q: data.query,
					fromTips: data.fromTips,
					cat: data.cat,
					detailSearch: true,
					searchOrigin: "fixed_suggestion",
				});
				Mapy.getComponent("logger").log("mainsearch", { q: data.query, text: data.title, index: -2 });
				Mapy.getComponent("history").save();
			},
			detailSuggest: true
		});

		return searchForm;
	}

	_setSuggest() {
		if (this._searchForm && this._stateSearch) {
			const query = this._stateSearch.query || getTitle(this._data, this._likeData) || "";
			this._dom.container.appendChild(this._searchForm.getContainer());
			this._searchForm.setQuery(query);
			this._searchForm.setDetailState(query, this._stateSearch.hasResults, this._stateSearch.width);
			this._searchForm.closeSuggest();
			if (Mapy.getComponent("layout").getWidth() != 0) {
				this._searchForm.focus();
			}
			this._dom.container.classList.add("has-suggest");
		}
		else {
			this._dom.container.classList.remove("has-suggest");
		}
	}

	// analytika
	_log = (action, data) => {
		const mergedData = Object.assign(
			{
				source: this._data.source,
				id: this._data.id,
				name: this._data.title,
			},
			data
		);
		Mapy.getComponent("logger").log(action, mergedData);
	}

	async _setWasmMarkerGeomVisibility(zoom: number) {
		const wasmContr = Mapy.getComponent("wasm");

		if (!this._geometry || !wasmContr.wasm || this._data?.extend?.signs) {
			return;
		}

		const bbox = this._geometry.getBBoxWgs84();
		const [minPx, maxPx] = await Promise.all([
			wasmContr.wasm.coordsToPixel(bbox.min),
			wasmContr.wasm.coordsToPixel(bbox.max),
		]);
		const width = Math.abs(maxPx.x - minPx.x);
		const height = Math.abs(maxPx.y - minPx.y);
		const size = Math.max(width, height);
		const bboxArea = width * height;
		let showMarker = true;
		let showGeom = true;

		if (zoom > 15 && bboxArea < 30 * 30 && size < 30) {
			// mala area - marker
			showMarker = true;
			showGeom = true;
		// testovaci oblast vuci konstante 70x70 (sirka a vyska); a zoom mensi jak 16
		} else if (zoom < 16 && bboxArea < 70 * 70 && size < 70) {
			// mala area - marker
			showMarker = true;
			showGeom = false;
		// velka area - zobrazime oblast
		} else {
			showMarker = false;
			showGeom = true;
		}

		this._wasmMarker.update({
			visible: showMarker,
		});
		this._wasmGeometry.update({
			visible: showGeom,
		});
	}
};
